import React from 'react';
import { Box } from '@mui/material';

export function Logo({ width = 120 }) {
  return (
    <Box
      component="img"
      src={process.env.PUBLIC_URL + '/Frame 4.png'}
      alt="Groni"
      sx={{
        width,
        height: 'auto',
        mb: 4,
        display: 'block'
      }}
    />
  );
} 